/* eslint-disable prefer-destructuring */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { withRouter } from 'react-router-dom';

import { sportTypeIds } from '../../../utils/eventConstants';
import SectionHeading from '../../../components/text/SectionHeading';
import SectionHeadingWrapper from '../../../components/text/SectionHeading/HeadingWrapper';
import { EventCard } from '../../../components/cards';

import { getPaidHits, applySearchFilters } from '../../../actions/search-actions';
import { tomorrowDateGmt } from '../../SearchPage/Filters/FilterComponents/DateFilter';

const PaidHits = (props) => {
    // component props
    const { filterPreferences } = props;
    // redux mapping
    const { paidHits = [], loading, auth } = props;

    useEffect(() => {
        if (!paidHits.length && !loading) {
            props.getPaidHits(filterPreferences);
        }
    }, [filterPreferences]);

    const onViewAllClick = () => {
        const { location, lat, lng, utrMin = 1, utrMax = 16, distance } = filterPreferences;
        props.applySearchFilters({
            type: 'paidHits',
            startDate: tomorrowDateGmt,
            distance,
            location,
            lat,
            lng,
            utrMin,
            utrMax,
        }, true);
        props.history.push('/search');
    };

    const { feedPreferences: { showTennisContent, showPickleballContent } } = auth;
    const filteredPaidHits = paidHits.filter(event => {
        if (!!showTennisContent && event?.source?.sportTypeId === sportTypeIds.TENNIS) {
            return true;
        } if (!!showPickleballContent && event?.source?.sportTypeId === sportTypeIds.PICKLEBALL) {
            return true;
        }
        return false;
    });

    return (
        <div>
            <div className="row mt64">
                <div className="col-12">
                    <SectionHeadingWrapper>
                        <SectionHeading title={'Paid Hits'} data-testid="dashboard.paid-hits.section-heading" />
                        <div className={`link clickable`} onClick={onViewAllClick} data-testid="dashboard.paid-hits.view-all-btn">
                            View All
                        </div>
                    </SectionHeadingWrapper>
                </div>
            </div>
            <div className="row">
                {filteredPaidHits?.length ? (
                    filteredPaidHits.map((hit) => {
                        return (
                            <div
                                className={`col-12 col-md-6 col-xl-4`}
                                key={hit.source.id}
                            >
                                <EventCard
                                    event={hit.source}
                                    auth={auth}
                                    force={{
                                        cardView: true,
                                    }}
                                    showRegister={true}
                                    data-testid={`dashboard.paid-hits.item-${hit.source.id}`}
                                />
                            </div>
                        );
                    })
                ) : (
                    <div className="col" data-testid="dashboard.paid-hits.empty-message">There are no paid hits in your area</div>
                )}
            </div>
        </div>
    );
};

PaidHits.propTypes = {
    paidHits: PropTypes.instanceOf(Array),
    loading: PropTypes.bool,
    auth: PropTypes.instanceOf(Object).isRequired,
};

PaidHits.defaultProps = {
    paidHits: [],
    loading: false,
};

function mapStateToProps({ homepage, auth }) {
    const { paidHits = {} } = homepage;
    const { data, loading, error } = paidHits;
    return { paidHits: data, loading, error, auth };
}
const mapDispatchToProps = {
    getPaidHits,
    applySearchFilters,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PaidHits));
